import { TLocation } from '../../types/location';

export function getLocationName(location: TLocation): string {
  if (location === 'moscow_mo') {
    return 'Московсая область';
  }

  if (location === 'spb_lo') {
    return 'Ленинградская область';
  }

  return location.displayName || '';
}
